import { useEffect, useState } from "react";
import { Users2 } from "lucide-react";
import { api } from "@/lib/api";

export default function JawatankuasaMember() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/public/committee").then((r) => setData(r.data)).catch(() => {});
  }, []);

  return (
    <div className="p-6 sm:p-10" data-testid="member-jawatankuasa-page">
      <h1 className="font-display text-xl font-bold text-piks-black mb-1">Jawatankuasa</h1>
      {data?.term && <p className="text-sm text-piks-muted mb-6">{data.term.name}</p>}
      {!data || data.members.length === 0 ? (
        <div className="text-center py-16 text-piks-muted"><Users2 className="w-10 h-10 mx-auto mb-3 opacity-40" />Maklumat belum tersedia.</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {data.members.map((m) => (
            <div key={m.id} className="p-4 rounded-lg bg-white border border-piks-border text-center" data-testid={`member-committee-${m.id}`}>
              <div className="w-12 h-12 rounded-full bg-piks-ivory border border-piks-border mx-auto mb-2 flex items-center justify-center">
                <span className="font-display text-piks-black">{m.display_name?.[0]}</span>
              </div>
              <p className="text-sm font-semibold text-piks-black">{m.display_name}</p>
              <p className="text-[11px] text-piks-red font-medium">{m.position}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
